export default __webpack_public_path__ + "static/media/corpse_blossom.086d3bbd.png";